var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"p-badge",class:[`badge-${_vm.type}`, _vm.pill ? `badge-pill` : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }